/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Titles_SupportInputs */

const en_settings_titles_support = /** @type {(inputs: Settings_Titles_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Settings_Titles_SupportInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_titles_support = /** @type {((inputs?: Settings_Titles_SupportInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Titles_SupportInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_titles_support(inputs)
});